import styled from 'styled-components';

const CreateThread = styled.section``;

export default CreateThread;
